import { Form, InputNumber, Row, Col, Divider, Input } from 'antd';
import React, { useState, useEffect } from 'react';

const TotalsSection = ({ form, calculateTotals }) => {
  const [totals, setTotals] = useState({
    subtotal: 0,
    totalIva: 0,
    totalRetentions: 0,
    total: 0
  });

  // Actualizar totales cuando los valores del formulario cambien
  useEffect(() => {
    // Crear una función que actualice los totales
    const updateTotals = () => {
      const values = form.getFieldsValue();
      const calculatedTotals = calculateTotals(values);
      setTotals(calculatedTotals);
    };

    // Realizar cálculo inicial
    updateTotals();

    // Crear un intervalo para verificar cambios en el formulario
    const intervalId = setInterval(() => {
      updateTotals();
    }, 100); // Verificar cada 100ms

    return () => {
      clearInterval(intervalId); // Limpiar el intervalo cuando el componente se desmonte
    };
  }, [form, calculateTotals]);

  // También podemos usar form.getFieldValue directamente para mostrar valores actualizados
  const getFormTotal = (type) => {
    const values = form.getFieldsValue();
    const calculatedTotals = calculateTotals(values);
    return calculatedTotals[type];
  };

  return (
    <>
      <Divider orientation="left">Totales</Divider>

      <Row gutter={16}>
        <Col span={6}>
          <Form.Item label="Subtotal">
            <InputNumber
              style={{ width: '100%' }}
              readOnly
              value={getFormTotal('subtotal')}
              formatter={value => {
                const number = Number(value);
                if (isNaN(number)) return '$ 0.00';
                return `$ ${number.toLocaleString('es-AR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}`;
              }}
              parser={value => value.replace(/\$\s?|(,*)/g, '')}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="I.V.A">
            <InputNumber
              style={{ width: '100%' }}
              readOnly
              value={getFormTotal('totalIva')}
              formatter={value => {
                const number = Number(value);
                if (isNaN(number)) return '$ 0.00';
                return `$ ${number.toLocaleString('es-AR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}`;
              }}
              parser={value => value.replace(/\$\s?|(,*)/g, '')}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="Perc./Reten.">
            <InputNumber
              style={{ width: '100%' }}
              readOnly
              value={getFormTotal('totalRetentions')}
              formatter={value => {
                const number = Number(value);
                if (isNaN(number)) return '$ 0.00';
                return `$ ${number.toLocaleString('es-AR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}`;
              }}

              parser={value => value.replace(/\$\s?|(,*)/g, '')}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="Total">
            <InputNumber
              style={{ width: '100%' }}
              readOnly
              value={getFormTotal('total')}
              formatter={value => {
                if (!value) return '$ 0';
                const number = Number(value).toFixed(2);
                const [intPart, decPart] = number.split('.');
                const formatted = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                return `$ ${formatted}.${decPart}`;
              }}
              parser={value => value.replace(/\$\s?|(,*)/g, '')}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={24}>
          <Form.Item
            name="observations"
            label="Observaciones"
          >
            <Input.TextArea rows={4} />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default TotalsSection;